export default {
  namespaced: true,
  state: {
    active: 9999,
    profile: false,
    toggle: false,
    headerName : "",
  },
  mutations: {
    setActive(state, value) {
      if (state.active == value) {
        state.active = 9999;
      } else {
        state.active = value;
      }
    },
    profile(state) {
      state.profile = !state.profile;
    },
    setToggle(state) {
      state.toggle = !state.toggle;
    },
    setHeaderName(state, value) {
      state.headerName = value;
    }
  },
};
